import { render, staticRenderFns } from "./queryCheck.vue?vue&type=template&id=2130c1a0&scoped=true"
import script from "./queryCheck.vue?vue&type=script&lang=js"
export * from "./queryCheck.vue?vue&type=script&lang=js"
import style0 from "./queryCheck.vue?vue&type=style&index=0&id=2130c1a0&prod&scoped=true&lang=scss"
import style1 from "./queryCheck.vue?vue&type=style&index=1&id=2130c1a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2130c1a0",
  null
  
)

export default component.exports